import { OLButton } from "OLButton";
import { ExternalLinkTooltipContent } from "components/Tooltips/ExternalLinkTooltip";
import { Tooltip } from "components/Tooltips/Tooltip";
import { ReactElement } from "react";
import { ConditionalWrap } from "utilities/ConditionalWrap";

interface Props {
  "data-test-id"?: string;
  disabled?: boolean;
  disabledInfo?: { name: string; text: string };
  onClick: () => void;
  size?: "small" | "medium" | "large";
  text: string;
  variant?: "contained" | "outlined";
}

export const SubheaderActionButton = ({
  "data-test-id": dataTestId,
  disabled,
  disabledInfo,
  onClick,
  size = "medium",
  text,
  variant,
}: Props) => {
  return (
    <ConditionalWrap
      condition={!!(disabledInfo && disabled)}
      wrap={(text: ReactElement) => (
        <Tooltip
          text={
            <ExternalLinkTooltipContent
              name={disabledInfo?.name as string}
              text={disabledInfo?.text as string}
            />
          }
        >
          {text}
        </Tooltip>
      )}
    >
      <span>
        <OLButton
          data-test-id={dataTestId && dataTestId}
          disabled={disabled}
          onClick={onClick}
          size={size}
          variant={variant ? variant : undefined}
        >
          {text}
        </OLButton>
      </span>
    </ConditionalWrap>
  );
};
